
import './footer.css'
function Footer() {
  return (
    <footer id='footer'>
      {/* // <div className="footer-container"> */}
        <h4>Made with❤️by Dhanush</h4>
      {/* // </div> */}
    </footer>
  )
}

export default Footer